import { Card, CardContent } from "../components/ui/card";
import { FileText, FilePlus, RefreshCw } from "lucide-react";

const LAEPage = () => {
  const modules = [
    { title: "Licencias", description: "Solicitud y emisión de licencias", icon: FilePlus, color: "yellow" },
    { title: "Renovaciones", description: "Proceso de renovación anual", icon: RefreshCw, color: "green" }
  ];

  return (
    <div className="space-y-6" data-testid="lae-page">
      {/* Header */}
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center">
          <FileText className="w-6 h-6 text-yellow-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Permisos Municipales
          </h1>
          <p className="text-slate-500">Gestión de permisos y licencias municipales</p>
        </div>
      </div>

      {/* Module Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {modules.map((module, index) => {
          const Icon = module.icon;
          return (
            <Card key={index} className="card-hover cursor-pointer group" data-testid={`lae-module-${index}`}>
              <CardContent className="p-6">
                <div className={`w-12 h-12 bg-${module.color}-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${module.color}-600`} />
                </div>
                <h3 className="font-semibold text-slate-900 mb-1">{module.title}</h3>
                <p className="text-sm text-slate-500">{module.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>

    </div>
  );
};

export default LAEPage;
